

































import { Component, Vue, Prop } from "vue-property-decorator"
import CapPrintVue from "./CapPrint.vue"
import { mapGetters } from "vuex"
import ReportMarginVue from "./ReportMargin.vue"
import AccountingSystem from "@/data/AccountingSystem";

@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "cap": CapPrintVue,
        "report-margin": ReportMarginVue

    }
})
export default class CashPrint extends Vue {
    @Prop({ type: Array })
    dataList!: CashFlow.CashData[];

    @Prop({ type: Array })
    period!: Date[];

    @Prop({ type: String })
	fontSize!: string;

    isSeven = this.$store.state.accountBook.accountingSystem === AccountingSystem.sevenNormal;

    get endPeriod() {
        let start = this.$utils.simpleDateFormat(this.period[0], "m"),
            end = this.$utils.simpleDateFormat(this.period[1], "m");
        if (start === end) return end;
        else {
            return `${start}至${end}`;
        }
    }
}
